import { Component } from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from "rxjs";
import {ApiServiceService} from "../../../Services/api-service.service";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import * as alertify from "alertifyjs";

@Component({
    selector: 'app-getInTouch',
    templateUrl: './get-in-touch.component.html',
    styleUrls: ['./get-in-touch.component.css']
})

export class getInTouchComponent {
    private apiUrl = 'https://google.com/api';
    private headers = new HttpHeaders({
        'content-type': 'application/json',
        'x-rapidapi-host': 'random-facts2.p.rapidapi.com',
        'x-rapidapi-key': 'your-api-key'
    });

  
    contactForm:any = FormGroup;


    constructor(private http: HttpClient, private  apiService:ApiServiceService, private fb:FormBuilder) { }

    ngOnInit(){

        this.initializeForm()
     
    }

    initializeForm(){

        this.contactForm = this.fb.group({
            fullName:['', Validators.required],
            emailAddress:['', [Validators.required, Validators.email]],
            msgBody:['', Validators.required]
        })

    }

    submitContactUs(){

        if (this.contactForm.invalid) {
            alertify.set("notifier", "position", "top-center");
            alertify.error("Fill all fields");
            return;
          }
        const  contact = {
            name: this.contactForm.get('fullName').value,
            email: this.contactForm.get('emailAddress').value,
            message: this.contactForm.get('msgBody').value,
        }

        const url = "/auth/utility/send/home-page/request";

       this.apiService.loginPost_(url, contact).subscribe(res=>{

        this.initializeForm()

           alertify.set("notifier", "position", "top-center");
           alertify.success("Request sent successfully");
       })
    }
}
